// src/components/PrivateAdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserData } from '../hooks/useUserData';

export default function PrivateAdminRoute({ children }) {
  const { user, userData, loading } = useUserData();

  console.log('PrivateAdminRoute DEBUG:');
  console.log('  user:', user ? user.uid : 'null');
  console.log('  userData:', userData);
  console.log('  loading (total):', loading);
  console.log('  userData?.role:', userData?.role);
  console.log('  isAdmin check:', userData?.role === 'admin');

  if (loading) {
    console.log('  Status: Carregando...');
    return <div>Carregando...</div>;
  }

  if (!user) {
    console.log('  Status: Usuário não logado. Redirecionando para /');
    return <Navigate to="/" replace />;
  }

  if (userData?.role !== 'admin') {
    console.log(
      '  Status: Usuário não é admin. Role:',
      userData?.role,
      '. Redirecionando para /'
    );
    return <Navigate to="/" replace />;
  }

  console.log('  Status: Acesso permitido.');
  return children;
}
